(() => {
  const updateStickyOffset = () => {
    const sticky = document.querySelector('[data-sticky-addcart], .t4s-sticky-atc, .t4s-sticky-atc__product');
    if (!sticky) return;

    const height = sticky.getBoundingClientRect().height;
    if (height > 0) {
      document.documentElement.style.setProperty('--product-seo-sticky-offset', `${Math.ceil(height)}px`);
    }
  };

  window.addEventListener('load', updateStickyOffset, { once: true });
  window.addEventListener('resize', updateStickyOffset);
  document.addEventListener('variant:change', updateStickyOffset);
})();
